/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import Typography from '../Typography';
import {SecondaryButton} from '@egalite/ui/Buttons/GeneralButtons';
import Link from 'next/link';
import { Fragment } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import Icon from '../Icon';
import clx from 'classnames';

const ConditionLink = ({ isLink, href, children }) => (isLink ? <Link href={href}>{children}</Link> : <div>{children}</div>);

const StepAnchor = ({ label, icon, link = '/',  active, done, last = false, className }) => {
	return (
		<Fragment>
			<ConditionLink href={link} isLink={done}>
				<div className={clx("`grow-0 shrink-0 flex items-center",
				done ? "hover:cursor-pointer" : "", className) } >
					<div className={
						clx("icon flex h-[55px] w-[55px] rounded-full border-2 border-solid items-center justify-center mr-12 transition-all duration-500 text-[24px]",
						active ? "bg-brand-main border-brand-main text-white" : "bg-transparent border-base-grey-4 text-base-grey-4",
						done ? "!bg-brand-light border-brand-main text-brand-main hover:cursor-pointer hover:!bg-brand-dark hover:border-brand-dark hover:text-white" : " ",
						className)}
					>
							{icon}
					</div>
					<Typography variant="body-2"
						className={clx("label block font-bold", active ? "text-brand-main" : "text-base-grey-4", done ? "text-base-grey-5 hover:underline" : " ", className )}>
						{label}
					</Typography>
				</div>
			</ConditionLink>
			{!last ? (
				<div
					className={clx("w-[32px] border-l-2 h-[50px] ml-11", done ? "border-solid border-brand-main" : "border-dashed border-base-grey-4", className)} />
			) : null}
		</Fragment>
	);
};

const Steps = ({ actualStep = 1, progress = 0, icons = [], labels = [], links = [], title = '', subtitle = '', actionButtonText = null, actionButtonUrl, open = false }) => {
	const searchParams = useSearchParams();

	const makeSteps = (actualStep, icons, labels, progress) =>
		icons.map((_, index) => {
			return {
				icon: icons[index],
				label: labels[index],
				link: links[index],
				done: index < progress || index < actualStep - 1,
				active: index === actualStep - 1,
			};
		});
	return (
		<div className='flex max-w-[350px] mt-6 lg:mt-36 flex-col justify-between gap-40' >
			<div>
				<Typography variant="headline-1" asEl="h1" className='text-base-grey-5 whitespace-normal w-full mb-6'>
					{title}
				</Typography>
				<Typography variant="body-2">{subtitle}</Typography>
			</div>
			<div className="flex flex-col items-start w-full mt-32 mb-52 lg:mt-3 lg:mb-20" >
				{makeSteps(actualStep, icons, labels, progress).map((item, index, { length }) => (
					<StepAnchor 
						key={item.label} 
						link={item.link} 
						label={item.label} 
						icon={item.icon} 
						active={item.active} 
						done={item.done} 
						last={index === length - 1} />
				))}
			</div>
			<Link href={searchParams.get('backUrl') ?? actionButtonUrl ?? '/'} passHref>
				<SecondaryButton
					className='mt-100 w-[350px] flex justify-center items-center'
					icon={<Icon className="fi fi-br-arrow-left mr-4" />}
					>
					<Typography className='text-base'>
						<strong>
						{actionButtonText ?? (searchParams.get('backUrl') ? 'Voltar' : 'Voltar para a home')}
						</strong>
					</Typography>
				</SecondaryButton>
			</Link>
		</div>
	);
};

export default Steps;